import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import Landscape from '../../assets/customSVG/Landscape';
import { ICONS } from '../../assets/icons';
import { Tooltip } from 'antd';

const OrderDetailTemplate = ({ data = {}, message = {}, settings = {} }) => {
  // Extract data from message template
  const header = message?.template?.find((item) => item.type === 'HEADER');
  const body = message?.template?.find((item) => item.type === 'BODY');
  const footer = message?.template?.find((item) => item.type === 'FOOTER');
  const buttons =
    message?.template?.find((item) => item.type === 'BUTTONS')?.buttons || [];

  // Get product image from the first product's image_url if available, otherwise fallback to header image
  const productImage =
    settings?.products?.[0]?.image_url || header?.example?.header_handle?.[0];

  // Get product names from settings and join with commas if multiple
  const productName =
    settings?.products?.length > 1
      ? settings.products
          .map((p) => p.name)
          .filter(Boolean)
          .join(', ')
      : settings?.products?.[0]?.name || 'Product';

  // Get reference ID and payment status from settings
  const total = settings?.total
    ? ` ₹${(settings.total / 100).toFixed(2)}`
    : 'N/A';
  const referenceId = settings?.reference_id || 'N/A';
  const isPaid = settings?.paid || false;
  return (
    <div className="w-full max-w-sm bg-[#D8FBD2] rounded-lg border border-gray-100">
      {/* Order Header */}
      <div className="px-2 pt-1 pb-1">
        <div className="flex justify-between items-center mb-3">
          <span className="text-gray-400 text-xs">ORDER #{referenceId}</span>
          {isPaid && (
            <div className="flex items-center gap-1">
              <CheckCircleFilled className="text-green-500 text-base" />
              <span className="text-gray-600 text-sm">Paid</span>
            </div>
          )}
        </div>

        <div className="border-t border-dashed border-[#0000001A] my-[0.3vw]"></div>

        {/* Product Details */}
        <div className="flex items-center gap-3 my-3">
          <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded">
            {productImage ? (
              <img
                src={productImage}
                alt="Product"
                className="w-full h-full object-cover"
              />
            ) : (
              <Landscape color="#A3A7AC" width={24} height={24} />
            )}
          </div>

          <div className="flex-1">
            <h3 className="text-gray-900 font-medium text-base leading-tight">
              {productName}
            </h3>
            <p className="text-gray-500 text-xs mt-0.5">
              Quantity: {settings.quantity || 1}
            </p>
          </div>
        </div>

        <div className="flex justify-between">
          <p className="text-gray-500 text-xs mt-0.5">Total:</p>
          <p className="text-gray-500 text-xs mt-0.5">{total}</p>
        </div>

        <div className="border-t border-gray-200 my-2"></div>

        {/* Body Content */}
        {body?.text && (
          <div className="my-3">
            <p className="text-gray-700 text-sm leading-relaxed">{body.text}</p>
          </div>
        )}
      </div>

      {/* Footer Content */}
      {footer?.text && (
        <div className="">
          <p className="text-gray-400 text-xs">{footer.text}</p>
        </div>
      )}

      {data?.status === "BOUNCED" && (
        <Tooltip title={JSON.stringify(data?.error_notes)}>
          <div className="flex-row align-center justify-end gap-1 text-[0.8rem] cursor-pointer font-[500] text-[#FF543E] ptb-5">
            <img src={ICONS?.inboxBounced} alt="" />
            Unable to send the message!
          </div>
        </Tooltip>
      )}

      {/* Action Buttons */}
      {buttons.length > 0 && (
        <div className="px-2 pb-1 pt-1 space-y-2 bg-[#D8FBD2]">
          {buttons.map((button, index) => (
            <div
              key={index}
              className="w-full flex items-center justify-center gap-[0.5vw] py-[0.5vw] rounded-[0.5vw] cursor-default text-[#007AFF] text-sm"
            >
              {button.text}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderDetailTemplate;
